import React from "react";
import { useContext, useEffect, useState } from "react";
import { BookContext } from "../context/BookContext";
import ReactLoading from "react-loading";
import {
  MDBContainer,
  MDBIcon,
  MDBListGroupItem,
  MDBListGroup,
  MDBBadge,
  MDBCol,
  MDBRow,
  MDBBtn,
} from "mdbreact";
import { Link } from "react-router-dom";
import "../App.css";
import LentForm from "./LentForm";
import { Authcontext } from "../context/Authcontext";
import IndividualBook from "./IndividualBook";

const ShowBooks = (props) => {
  const { displayBookList, BookList, Loading, sortBooks } = useContext(
    BookContext
  );
  const { User } = useContext(Authcontext);
  const [modal, setmodal] = useState(false);

  const toggle = () => {
    setmodal(!modal);
  };

  useEffect(() => {
    if (props.match.params.option) {
      sortBooks(props.match.params.option, User);
    } else {
      console.log("showbook");
      console.log(User);
      displayBookList(User);
    }
  }, [props.match.params.option]);
  return (
    <div>
      <MDBContainer>
        <MDBRow md="50">
          <MDBCol md="2"></MDBCol>
          <MDBCol md="8">
            {Loading == true ? (
              <ReactLoading
                type="bubbles"
                color="#c51162"
                height={500}
                width={500}
              />
            ) : BookList.length == 0 ? (
              <h1 style={{ textAlign: "center" }}>No books found</h1>
            ) : (
              <div>
                {" "}
                <h2 style={{ marginTop: "20px", textAlign: "center" }}>
                  Books
                </h2>
                {BookList.map((item, index) => ( 
                <div>
                  <IndividualBook
                    item={item}
                    modal={modal}
                    toggle={toggle}
                    index={index}
                  />
                </div>
                ))}
              </div>
            )}
          </MDBCol>
          <MDBCol md="2"></MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
};
export default ShowBooks;
